'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");

var cursor_pointer = Curry._1(Css.style, {
      hd: Css.cursor("pointer"),
      tl: /* [] */0
    });

var no_default_style = Curry._1(Css.style, {
      hd: Css.border({
            NAME: "px",
            VAL: 0
          }, "none", Css.transparent),
      tl: {
        hd: Css.backgroundColor(Css.transparent),
        tl: {
          hd: Css.margin({
                NAME: "px",
                VAL: 0
              }),
          tl: {
            hd: Css.padding({
                  NAME: "px",
                  VAL: 0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var flex_start_stretch = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("flexStart"),
        tl: {
          hd: Css.alignItems("stretch"),
          tl: /* [] */0
        }
      }
    });

var flex_start_start = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("flexStart"),
        tl: {
          hd: Css.alignItems("flexStart"),
          tl: /* [] */0
        }
      }
    });

var flex_start_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("flexStart"),
        tl: {
          hd: Css.alignItems("center"),
          tl: /* [] */0
        }
      }
    });

var flex_between_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("spaceBetween"),
        tl: {
          hd: Css.alignItems("center"),
          tl: /* [] */0
        }
      }
    });

var flex_center_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("center"),
        tl: {
          hd: Css.alignItems("center"),
          tl: /* [] */0
        }
      }
    });

var flex_around_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("spaceAround"),
        tl: {
          hd: Css.alignItems("center"),
          tl: /* [] */0
        }
      }
    });

var flex_evenly_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("spaceEvenly"),
        tl: {
          hd: Css.alignItems("center"),
          tl: /* [] */0
        }
      }
    });

var flex_col_start_start = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("column"),
        tl: {
          hd: Css.justifyContent("flexStart"),
          tl: {
            hd: Css.alignItems("flexStart"),
            tl: /* [] */0
          }
        }
      }
    });

var flex_col_start_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("column"),
        tl: {
          hd: Css.justifyContent("flexStart"),
          tl: {
            hd: Css.alignItems("center"),
            tl: /* [] */0
          }
        }
      }
    });

var flex_col_between_center = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("column"),
        tl: {
          hd: Css.justifyContent("spaceBetween"),
          tl: {
            hd: Css.alignItems("center"),
            tl: /* [] */0
          }
        }
      }
    });

var align_self_start = Curry._1(Css.style, {
      hd: Css.alignSelf("selfStart"),
      tl: /* [] */0
    });

var align_self_end = Curry._1(Css.style, {
      hd: Css.alignSelf("selfEnd"),
      tl: /* [] */0
    });

exports.cursor_pointer = cursor_pointer;
exports.no_default_style = no_default_style;
exports.flex_start_stretch = flex_start_stretch;
exports.flex_start_start = flex_start_start;
exports.flex_start_center = flex_start_center;
exports.flex_between_center = flex_between_center;
exports.flex_center_center = flex_center_center;
exports.flex_around_center = flex_around_center;
exports.flex_evenly_center = flex_evenly_center;
exports.flex_col_start_start = flex_col_start_start;
exports.flex_col_start_center = flex_col_start_center;
exports.flex_col_between_center = flex_col_between_center;
exports.align_self_start = align_self_start;
exports.align_self_end = align_self_end;
/* cursor_pointer Not a pure module */
